import { ArrowRight, MessageCircle } from "lucide-react";
import { waLink } from "@/lib/site";

export const CtaBand = () => {
  return (
    <section className="relative bg-brand-navy py-20 lg:py-24 overflow-hidden">
      <div className="grain-overlay" />
      <div className="relative mx-auto max-w-4xl px-5 sm:px-8 text-center">
        <h2 className="font-display font-bold uppercase tracking-tight leading-none text-white text-4xl sm:text-5xl">
          Prêt à transformer votre sourcing ?
        </h2>
        <p className="mt-5 text-white/70 text-base lg:text-lg max-w-2xl mx-auto">
          Contactez-nous dès aujourd'hui pour une consultation gratuite. Découvrez comment King of
          Sourcing peut optimiser votre chaîne d'approvisionnement.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#devis"
            data-testid="cta-quote-btn"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-goldbright px-7 py-3.5 text-sm font-bold uppercase tracking-wide text-brand-navy hover:-translate-y-1 transition-transform duration-300"
          >
            Obtenir un devis gratuit <ArrowRight size={18} />
          </a>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-whatsapp-btn"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 px-7 py-3.5 text-sm font-bold uppercase tracking-wide text-white hover:bg-white/10 transition-colors duration-300"
          >
            <MessageCircle size={18} /> Nous contacter
          </a>
        </div>
      </div>
    </section>
  );
};
